module.exports = __webpack_public_path__ + "NoiseAware_MobileAppDashboardfcce053e45db5c0e05278e9c629431b4.png";